import { useContext } from "react"
import { ToastContext } from "stores"

export const useToastContext = () => useContext(ToastContext)
